import { Fragment, useCallback, useState } from 'react'
import * as S from './TableWrongProduct.styles'

import {
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow
} from 'src/components/TableComponents'
import { WrapperTableItem, ButtonCaret } from '../Components'
import SubTableWrongProduct from '../SubTableWrongProduct'

export const TableWrongProduct = ({ title, products }) => {
  const [showRowDetail, setShowRowDetail] = useState(
    Array(products.length).fill(false)
  )

  const handleShowRowDetail = useCallback(
    (index) => {
      const newArray = showRowDetail.slice()
      newArray[index] = !newArray[index]
      setShowRowDetail(newArray)
    },
    [showRowDetail]
  )

  if (products.length === 0) {
    return null
  }

  return (
    <WrapperTableItem>
      <S.Title>{title}</S.Title>
      <Table>
        <TableHead>
          <TableHeadRow>
            <TableHeadCell flex={2}>Produto</TableHeadCell>
            <TableHeadCell>Status</TableHeadCell>
            <TableHeadCell>Lotes</TableHeadCell>
          </TableHeadRow>
        </TableHead>
        <TableBody>
          {products.map((product, index) => {
            return (
              <Fragment key={product.id_produto_divergencia}>
                <TableBodyRow>
                  <TableBodyCell flex={2}>
                    {product.descricao_produto
                      ? product.descricao_produto
                      : 'Produto Desconhecido'}
                  </TableBodyCell>
                  <TableBodyCell>{product.status}</TableBodyCell>
                  <TableBodyCell>
                    <ButtonCaret
                      onClick={() => handleShowRowDetail(index)}
                      status={showRowDetail[index]}
                    />
                  </TableBodyCell>
                </TableBodyRow>
                {showRowDetail[index] && (
                  <S.SubTableRow>
                    <S.TDSubtable>
                      <SubTableWrongProduct product={product} />
                    </S.TDSubtable>
                  </S.SubTableRow>
                )}
              </Fragment>
            )
          })}
        </TableBody>
      </Table>
    </WrapperTableItem>
  )
}
